module.exports = __webpack_public_path__ + "static/BusinessInsider-icon-67e49d397ba059793ee58fcfa8df7794.svg";